
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.216 15.666c0 .44-.356.796-.796.796h-2.94a.796.796 0 110-1.592h2.94c.44 0 .796.356.796.796zM1.263 9.498h21.375v10.744a.797.797 0 01-.797.796H2.06a.796.796 0 01-.796-.796V9.498zm19.782 0h-5.079a4.1 4.1 0 01-4.016 3.297 4.1 4.1 0 01-4.016-3.297H2.855v9.947h18.19V9.498zm-9.095 1.705a2.505 2.505 0 002.371-1.705H9.58a2.506 2.506 0 002.371 1.705zM24 1l-1.05 4.702c0 .44-.356.796-.796.796H1.746a.796.796 0 01-.796-.796L0 1C0 .56.356.204.796.204h22.408c.44 0 .796.356.796.796zm-3.955 5.498H3.855h16.19zm2.362-4.702H1.593l.636 3.11h19.442l.736-3.11zM9.58 9.498H1.263V7.96H9.58v1.538zm4.743-1.538h8.316v1.538H14.322V7.96z","fill-rule":"nonzero"}})])
          )
        }
      }
    